import script from "./object_images.vue?vue&type=script&setup=true&lang=js"
export * from "./object_images.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__